// Public beta-waitlist submit. POSTs the /waitlist form to the public endpoint.
// (The route is public; the bearer token apiClient may attach is harmless there.)
const { request } = require('./apiClient');

// payload: { email, name, job, reason, userId? }
function joinWaitlist(payload) {
  return request('/public/waitlist', {
    method: 'POST',
    body: payload
  }).then(function (r) {
    return r && r.entry ? r.entry : null;
  });
}

module.exports = {
  joinWaitlist: joinWaitlist
};
